import { createAsyncThunk } from '@reduxjs/toolkit';

import { getProductSymbol, getListOfProducts, submitProduct, getListOfPendingProducts, searchProduct, editProduct, delProduct, modifyProduct, getProduct, getLiveInstrumentsByProductID, getDeletedInstrumentsByProductID, getStageInstrumentsByProductID, productSearch } from './cruds';


export const ACTION_TYPE_PARENT = 'product'

// NOTE: keep function name and thunk child name same
export const fetchProductSymbol = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchProductSymbol`,
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getProductSymbol(payload.issuerId, payload.partial)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const fetchListOfProducts = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchListOfProducts`,
  async ({ issuerId, requestHeaders }: any, { rejectWithValue }) => {
    try {
      const response = await getListOfProducts(issuerId, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const fetchListOfPendingProducts = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchListOfPendingProducts`,
  async ({ requestHeaders }: any, { rejectWithValue }) => {
    try {
      const response = await getListOfPendingProducts(requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const createProduct = createAsyncThunk(`${ACTION_TYPE_PARENT}/createProduct`,
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitProduct(payload)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, errors: err.response.data?.errors })
    }

  }
)

export const updateProduct = createAsyncThunk(`${ACTION_TYPE_PARENT}/updateProduct`,
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await editProduct(payload)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, errors: err.response.data?.errors })
    }

  }
)

export const deleteProduct = createAsyncThunk(`${ACTION_TYPE_PARENT}/deleteProduct`,
  async (productId: number, { rejectWithValue }) => {
    try {
      const response = await delProduct(productId)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }

      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, errors: err.response?.data })
    }

  }
)

export const patchProduct = createAsyncThunk(`${ACTION_TYPE_PARENT}/patchProduct`,
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await modifyProduct(payload.productId, payload.status)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, errors: err.response.data?.errors })
    }

  }
)

export const setSelectedIssuer = createAsyncThunk(`${ACTION_TYPE_PARENT}/setSelectedIssuer`,
  async (payload: any, { rejectWithValue }) => {
    try {
      // const response = await submitProduct(payload)
      return payload;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const setSelectedProduct = createAsyncThunk(`${ACTION_TYPE_PARENT}/setSelectedProduct`,
  async (payload: any, { rejectWithValue }) => {
    try {
      return payload;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const searchProducts = createAsyncThunk(`${ACTION_TYPE_PARENT}/searchProducts`,
  async (payload: string, { rejectWithValue }) => {
    try {
      const response = await searchProduct(payload)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchProductDetails = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchProductDetails`,
  async (productId: number, { rejectWithValue }) => {
    try {
      const response = await getProduct(productId)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchLiveInstrumentsByProductID = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchLiveInstrumentsByProductID`,
  async (productId: number, { rejectWithValue }) => {
    try {
      const response = await getLiveInstrumentsByProductID(productId)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchDeletedInstrumentsByProductID = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDeletedInstrumentsByProductID`,
  async (productId: number, { rejectWithValue }) => {
    try {
      const response = await getDeletedInstrumentsByProductID(productId)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchStageInstrumentsByProductID = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchStageInstrumentsByProductID`,
  async (productId: number, { rejectWithValue }) => {
    try {
      const response = await getStageInstrumentsByProductID(productId)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchProductWithFilters = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchProductWithFilters`,
  async ({ payload, requestHeaders }: any, { rejectWithValue }) => {
    try {
      const response = await productSearch(payload, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data })
    }
  }
)

